import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import EntityFilterListItem from './EntityFilterListItem';
import {FixedSizeList as List} from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import SearchInput from 'components/SearchInput';
import {filterByValue} from 'Helpers/filterByValue';

const SavedSearchesEntityFilters = (props) => {
    const {entities, activeEntities, entitiesLoading, handleEntitySelect, updating, toggleAllEntities} = props;

    const [collapseOpen, setCollapseOpen] = useState(true);
    const [visibleList, setVisibleList] = useState([]);
    const [searchValue, setSearchValue] = useState('');

    const toggleCollapse = () => setCollapseOpen(!collapseOpen);
    const resetSearch = () => setSearchValue('');

    useEffect(() => {
        if(entities) {
            let filteredArr = searchValue.length ? filterByValue(entities, 'title', searchValue) : [...entities];
            setVisibleList(filteredArr);
        }
    }, [searchValue, entities]);


    const Row = ({index, style}) => (
        <div key={index} style={{...style, margin: '0 auto'}}>
            <EntityFilterListItem
                entity={visibleList[index]}
                activeEntities={activeEntities}
                handleEntitySelect={handleEntitySelect}
                updating={updating}
            />
        </div>
    );

    return (
        <div className="saved-searches-entity-filters">
            <div className="saved-searches-entity-filters__header">
                <div className="d-flex justify-content-between align-items-center">
                    <div style={{fontSize: '20px', fontWeight: 700, display: 'flex'}}>
                        Entities
                    </div>
                    {(entities && entities.length > 0) &&
                    <div>
                        {activeEntities.length === 0 ?
                            <div className="search_page-icon" onClick={() => handleEntitySelect(null, true)}>
                                <i className="fas fa-check-circle"/> Select all
                            </div>
                            :
                            <div className="search_page-icon" onClick={() => handleEntitySelect(null, true)}>
                                <i className="fa fa-times-circle "/> Clear all ({activeEntities.length} of {entities.length})
                            </div>
                        }
                    </div>
                    }
                </div>
                <div style={{padding: '10px 0 0'}}>
                    {(entities && entities.length > 0) &&
                    <SearchInput
                        value={searchValue}
                        onChange={setSearchValue}
                        placeholder="Search by entity name"
                        onClear={resetSearch}
                    />
                    }
                </div>
            </div>
            <div className="saved-searches-entity-filters__body">
                {/*{collapseOpen &&*/}
                {/*<div*/}
                {/*    className={`saved-searches-entity-filters__collapse ${collapseOpen ? ' saved-searches-entity-filters__collapse--open' : ''}`}>*/}
                    {entitiesLoading ?
                        <div className="flex-centered" style={{width: '100%', height: '100px'}}>
                            <i className="fa fa-spinner fa-spin"/>
                        </div>
                        :
                        <div className="d-flex flex-grow-1">
                            {entities && entities.length > 0 ?
                                <div style={{flex: '1 1 auto'}}>
                                    {/*<div style={{padding: '10px 15px'}}>*/}
                                    {/*    <SearchInput*/}
                                    {/*        value={searchValue}*/}
                                    {/*        onChange={setSearchValue}*/}
                                    {/*        placeholder="Search saved searches"*/}
                                    {/*        onClear={resetSearch}*/}
                                    {/*    />*/}
                                    {/*</div>*/}
                                    <AutoSizer>
                                        {({height, width}) => (
                                            <List
                                                width={width}
                                                height={height}
                                                itemCount={visibleList.length}
                                                itemSize={57}
                                            >
                                                {Row}
                                            </List>
                                        )}
                                    </AutoSizer>
                                    {/*{entities.map(entity => (*/}
                                    {/*    <EntityFilterListItem*/}
                                    {/*        key={entity.id}*/}
                                    {/*        entity={entity}*/}
                                    {/*        activeEntities={activeEntities}*/}
                                    {/*        handleEntitySelect={handleEntitySelect}*/}
                                    {/*    />*/}
                                    {/*))}*/}
                                </div>
                                :
                                <div style={{paddingBottom: '10px'}}>
                                    There are no entities yet.<br/>
                                    Create one <Link to="/add-entity"
                                                     style={{textDecoration: 'underline', color: '#321fdb'}}>here</Link>
                                </div>
                            }
                        </div>
                    }
                {/*</div>*/}
                {/*}*/}
            </div>
        </div>
    );
};

export default SavedSearchesEntityFilters;
